import Link from "@components/Link";
import { Container } from "@styles/GlobalStyles";
import styled, { css } from "styled-components";

export const Nav = styled.nav`
  font-size: 18px;
  position: sticky;
  top: 0;
  z-index: 999;
  height: 110px;
  background-color: #2e1c65;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const NavbarContainer = styled(Container)`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  width: calc(100% - 2rem);
  max-width: 1380px;
  padding-top: 20px;
  height: 110px;

  ${Container};
`;

export const NavHeaderLineWrap = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
`;

export const AccountInfoWrap = styled.div`
  display: flex;
  gap: 10px;
  color: #fff;
`;

export const StyledInfo = styled.div`
  display: flex;
  align-items: start;
  align-items: center;
  font-family: "Inter" sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 28px;
  color: #ffffff;
  & img {
    margin-right: 10px;
    font-size: 30px;
    fill: #ffffff80;
  }
`;

export const NavLogo = styled.div`
  color: #fff;
  cursor: pointer;
  height: 28px;
  display: flex;
  align-items: center;
  text-decoration: none;
  font-size: 2.5rem;
  font-weight: 800;
  transition: all 0.5s ease;

  & svg path {
    height: 40px;
  }
`;

export const Menu = styled.ul`
  display: flex;
  height: 38px;
  align-items: center;
  justify-content: flex-start;
  text-align: center;
`;

export const MenuLink = styled(Link)`
  text-decoration: none;
  font-weight: bold;
  font-size: 2rem;
  vertical-align: middle;
  align-items: center;
  margin-right: 45px;
  height: 28px;
  padding-bottom: 10px;
  transition: all 0.2s ease;

  &:hover {
    color: #cd6ee5;
  }
  &:active {
    transform: traslateY(3rem);
    color: #e38b06;
    /* & svg path {
      fill: #CD6EE5;
      
    } */
  }

  & span {
    margin-left: 8px;
  }
`;

export const StyledButton = styled.div<{
  $activeitem: string | boolean;
  $pathname: string;
}>`
  display: flex;
  flex-direction: row;
  font-weight: 600;
  line-height: 28px;
  font-size: 14px;
  color: #fff;
  /* display: block; */
  height: 28px;
  transition: all 0.2s ease;
  background-color: #2e1c65;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  box-sizing: border-box;

  & span {
    /* display: inline-block; */
    width: ${({ $pathname }) => ($pathname.includes("admin") ? "100%" : "90%")};
    word-wrap: break-word;
    text-align: center;
  }

  & svg path {
    height: 22px;
    width: 22px;
    fill: #ffffff80;
  }

  &:active {
    color: #e38b06;
    & svg path {
      fill: #cd6ee5;
    }
  }

  &:hover {
    color: #cd6ee5;
    border-bottom: 5px solid #cd6ee5;
    /* transform: traslateY(-3rem); */
    & svg path {
      fill: #cd6ee5;
    }
  }

  ${({ $activeitem }) => {
    return (
      $activeitem &&
      css`
        color: #cd6ee5;
        & svg path {
          fill: #cd6ee5;
        }
      `
    );
  }}
`;

export const Submenu = styled.div<{
  height?: number;
}>`
  position: absolute;
  max-width: 1366px;
  height: ${({ height }) => (height ? `${height}px` : "100px")};
  top: 101%;
  background: #2e1c65;
  ${MenuLink}:hover & {
    display: block;
  }
`;

export const SubmenuBackground = styled.div<{
  height?: number;
}>`
  position: absolute;
  width: 100%;
  height: ${({ height }) => (height ? `${height}px` : "100px")};
  top: 101%;
  background: #2e1c65;

  ${MenuLink}:hover & {
    display: block;
  }
`;
